import React from 'react';
import CollectionItemCard from '../components/CollectionItemCard';

const renderItemCards = (itemsArray, setWindowLocationHash, setItemId, setCurrentModalItemIndex, setModalIsOpen) => {
	if (!itemsArray.length) return null;
	return itemsArray.map((item, index) => {
		return <CollectionItemCard
			data-aos="fade-up" 
			key={item.id}
			title={item.title}
			subtitle={item.subtitle}
			imgSrc={item.image.url}
			altText={item.alt_text}
			itemId={String(item.id)}
			index={index}
			setWindowLocationHash={setWindowLocationHash}
			setItemId={setItemId}
			setCurrentModalItemIndex={setCurrentModalItemIndex}
			setModalIsOpen={setModalIsOpen}
		/>
	})
}

export default renderItemCards;